import { Component, computed, inject } from '@angular/core';
import { AppUpdateService } from '@app/services/app-update.service';

@Component({
    selector: 'app-update-notification',
    templateUrl: './app-update-notification.component.html',
    styleUrl: './app-update-notification.component.scss',
})
export class UpdateNotificationComponent {
    private readonly updateService = inject(AppUpdateService);

    readonly updateState = this.updateService.updateState;
    readonly isUpdateAvailable = this.updateService.isUpdateAvailable;
    readonly isUpdating = this.updateService.isUpdating;
    readonly isDismissed = this.updateService.isDismissed;
    readonly canUpdate = this.updateService.canUpdate;

    readonly showNotification = computed(
        () => (this.isUpdateAvailable() && this.isDismissed() === false) || !!this.updateState().error
    );

    updateNow() {
        this.updateService.activateUpdate();
    }

    dismiss() {
        this.updateService.dismissUpdate();
    }
}
